'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _healthChecks = require('../../src/styles/health-checks.scss');

var _healthChecks2 = _interopRequireDefault(_healthChecks);

require('../../src/styles/external.scss');

var _healthCheckPackages = require('./health-check-packages');

var _healthCheckPackages2 = _interopRequireDefault(_healthCheckPackages);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

// import styles from '../../src/styles/style.scss';
var DECIMAL_PLACES = 2;

/**
 * Returns the formatted price. Prices with decimal places will be formatted to
 * be displayed with two decimal places, adding trailing zeros if required.
 * @param {!Number} price The price.
 * @return {string} The formatted price.
 */
var formatPrice = function formatPrice(price) {
  return parseFloat(price).toFixed(DECIMAL_PLACES).replace(/\.00/, '');
};

/**
 * Returns the lowest price amongst all the packages.
 * @param {!Array<Object>} packages The packages of a health check.
 * @return {number} The lowest price amongst all the packages.
 */
var getLowestPrice = function getLowestPrice(packages) {
  return Math.min.apply(Math, packages.filter(function (item) {
    return item.price && item.price.length && item.price[0].length > 0;
  }).map(function (item) {
    return item.price[0];
  }));
};

/**
 * Returns an array of React elements containing the health checks.
 * @param {!Object} props The props provided to the React component.
 * @return {!Array<symbol>} React elements containing the health checks.
 */
var getHealthCheckElements = function getHealthCheckElements(props) {
  var healthCheckElements = [];

  props.healthChecks.forEach(function (healthCheck, index) {
    healthCheckElements.push(_react2.default.createElement(
      'div',
      { className: _healthChecks2.default.healthCheck,
        key: 'healthcheck' + index,
        'data-health-check-id': healthCheck.keyword_id
      },
      _react2.default.createElement(
        'div',
        { className: _healthChecks2.default.header, onClick: function onClick() {
            return props.onHealthCheckSelected(healthCheck.keyword_id);
          } },
        _react2.default.createElement('img', { src: (0, _doctifyUtils.getResourcePath)(healthCheck.icon_uri) }),
        _react2.default.createElement(
          'span',
          { className: _healthChecks2.default.name },
          healthCheck.name
        ),
        healthCheck.packages && getLowestPrice(healthCheck.packages) !== Infinity && getLowestPrice(healthCheck.packages) >= 0 && _react2.default.createElement(
          'span',
          { className: _healthChecks2.default.price },
          'From \xA3',
          '' + formatPrice(getLowestPrice(healthCheck.packages))
        ) || _react2.default.createElement(
          'span',
          { className: _healthChecks2.default.price },
          'Price unavailable'
        )
      ),
      healthCheck.keyword_id === props.activeHealthCheckId && _react2.default.createElement(
        'div',
        { className: _healthChecks2.default.body },
        _react2.default.createElement(
          'div',
          { className: _healthChecks2.default.description },
          healthCheck.description
        ),
        _react2.default.createElement(_healthCheckPackages2.default, {
          packages: healthCheck.packages,
          activePackageId: props.activePackageId,
          onPackageSelected: props.onPackageSelected,
          onBookButtonClicked: props.onBookButtonClicked,
          className: _healthChecks2.default.cards + ' ' + props.packagesClassName })
      )
    ));
  });

  return healthCheckElements;
};

// const HealthChecks = (props: HealthChecksData) => props.healthChecks && props.healthChecks.length &&
// 	<div className={`${healthCheckStyles.healthChecksContainer} ${props.className}`}>
// 		{getHealthCheckElements(props)}
// 	</div> || null;

getHealthCheckElements.propTypes = {
  healthChecks: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  activeHealthCheckId: require('react').PropTypes.number,
  activePackageId: require('react').PropTypes.number,
  onHealthCheckSelected: require('react').PropTypes.func,
  onPackageSelected: require('react').PropTypes.func,
  onBookButtonClicked: require('react').PropTypes.func.isRequired,
  className: require('react').PropTypes.string,
  packagesClassName: require('react').PropTypes.string
};

var HealthChecks = function (_React$Component) {
  (0, _inherits3.default)(HealthChecks, _React$Component);

  function HealthChecks(props) {
    (0, _classCallCheck3.default)(this, HealthChecks);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.scrollToActiveHealthCheck = _this.scrollToActiveHealthCheck.bind(_this);
    return _this;
  }

  HealthChecks.prototype.componentDidMount = function componentDidMount() {
    if (this.props.activeHealthCheckId && window) {
      this.scrollToActiveHealthCheck();
    }
  };

  HealthChecks.prototype.scrollToActiveHealthCheck = function scrollToActiveHealthCheck() {
    try {
      var mobileScreenWidth = 768;
      var activeElem = document.querySelector('[data-health-check-id="' + this.props.activeHealthCheckId + '"]');

      var scrollElem = activeElem;
      var offset = { x: 0, y: 0 };

      if (window.outerWidth < mobileScreenWidth) {
        while (scrollElem) {
          offset.x += scrollElem.offsetLeft;
          offset.y += scrollElem.offsetTop;
          scrollElem = scrollElem.offsetParent;
        }
      } else {
        while (scrollElem && scrollElem.id !== 'scrolldiv') {
          offset.x += scrollElem.offsetLeft;
          offset.y += scrollElem.offsetTop;
          scrollElem = scrollElem.offsetParent;
        }
      }

      if (document.documentElement && (document.documentElement.scrollTop || document.documentElement.scrollLeft)) {
        offset.x -= document.documentElement.scrollLeft;
        offset.y -= document.documentElement.scrollTop;
      } else if (document.body && (document.body.scrollTop || document.body.scrollLeft)) {
        offset.x -= document.body.scrollLeft;
        offset.y -= document.body.scrollTop;
      }

      var mobileNavbar = document.querySelector('.navbar-fixed-top');
      var offsetCorrection = -1; // -1px because of top border

      if (window.outerWidth < mobileScreenWidth && mobileNavbar) {
        offsetCorrection -= mobileNavbar.clientHeight; // correction for navbar
      }

      var element = scrollElem || document.documentElement || document.body; // scrollElement for desktop or body for mobile
      var start = element.scrollTop;
      var to = offset.y + offsetCorrection;
      var change = to - start;
      var startDate = +new Date();
      var duration = 800;
      // t = current time
      // b = start value
      // c = change in value
      // d = duration
      var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      var animateScroll = function animateScroll() {
        var currentDate = +new Date();
        var currentTime = currentDate - startDate;
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          element.scrollTop = to;
        }
      };
      animateScroll();
    } catch (e) {
      console.log('unsupported browser for DKB-194');
    }
  };

  HealthChecks.prototype.render = function render() {
    var props = this.props;
    return props.healthChecks && props.healthChecks.length && _react2.default.createElement(
      'div',
      { className: _healthChecks2.default.healthChecksContainer + ' ' + props.className },
      getHealthCheckElements(props)
    ) || null;
  };

  return HealthChecks;
}(_react2.default.Component);

HealthChecks.displayName = 'HealthChecks';

HealthChecks.defaultProps = {
  healthChecks: []
};

exports.default = HealthChecks;


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/health-checks.js